import { useState, useCallback } from 'react';
import { NodeViewWrapper, NodeViewContent } from '@tiptap/react';
import { copyToClipboard } from '@/lib/clipboard';

export default function CodeBlockView({ node, updateAttributes, extension }) {
  const [copied, setCopied] = useState(false);
  const language = node.attrs.language || '';

  const handleCopy = useCallback(async () => {
    const text = node.textContent;
    const result = await copyToClipboard(text);
    if (result.success) {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  }, [node]);

  return (
    <NodeViewWrapper className="code-block-wrapper" data-testid="code-block-wrapper">
      <div className="code-block-header" contentEditable={false}>
        <span className="code-block-lang" data-testid="code-block-lang">
          {language || 'plain'}
        </span>
        <button
          type="button"
          className={`code-block-copy${copied ? ' copied' : ''}`}
          onClick={handleCopy}
          data-testid="code-block-copy-btn"
        >
          {copied ? 'Copied' : 'Copy'}
        </button>
      </div>
      <pre spellCheck={false}>
        <NodeViewContent as="code" />
      </pre>
    </NodeViewWrapper>
  );
}
